module.exports = __webpack_public_path__ + "static/media/sass.0df43376.png";